/** Native source-readiness presentation; no fetching, sync dispatch or analytical policy. */
import type { InsightsReadiness } from '@testfeed/shopify-contracts'
import { insightsLoadingCopy } from '@testfeed/product-language'
import { buildSettingsViewUrl } from '../../resultsNavigation'
import { HouseEmptyState } from '../imagery/HouseEmptyState'
import { houseImagery } from '../imagery/houseImagery'
import { InsightsLoading } from './InsightsLoading'

const copy = insightsLoadingCopy.readiness

export function InsightsReadinessState({
  data,
  polling,
  checking,
  onRetry,
}: {
  data: InsightsReadiness
  polling: boolean
  checking: boolean
  onRetry: () => void
}) {
  const message = copy[data.state]
  let body: string = message.body
  if (data.state === 'blocked' && data.reason === 'privacy') body = copy.privacy
  if (data.state === 'preparing' && !polling) body = copy.paused
  if (data.state === 'preparing' && polling)
    return (
      <s-stack gap="base">
        <s-section>
          <s-banner heading={message.heading}>
            <s-paragraph>{body}</s-paragraph>
            <s-button slot="secondary-actions" href={buildSettingsViewUrl()}>
              {copy.settings}
            </s-button>
          </s-banner>
        </s-section>
        <InsightsLoading />
      </s-stack>
    )
  return (
    <s-section>
      <HouseEmptyState
        heading={message.heading}
        image={houseImagery.syncIntelligence}
        action={{ content: copy.settings, url: buildSettingsViewUrl() }}
        secondaryAction={{ content: copy.check, onAction: onRetry, disabled: checking }}
      >
        <s-paragraph>{body}</s-paragraph>
      </HouseEmptyState>
    </s-section>
  )
}
